export default __webpack_public_path__ + "static/btwo-logo-black-381d89329f8e22bc7530dce14dfdf2cd.svg";